<script lang="ts">
	interface Props {
		full?: boolean
		animate?: boolean
	}

	let { full = false, animate = true }: Props = $props()
</script>

<div
	class="
    inline-flex h-4 rounded-md bg-gray-300 dark:bg-gray-700
    {full ? 'w-full' : 'w-36'}
    {animate ? 'animate-pulse' : ''}"
></div>
